import { getLitiumContext } from "@shared/Services/litium-service";

type Translations = Record<string, string>;

export const getTranslations = (): Translations => {
  return getLitiumContext().translation ?? {};
};
